import { Role } from './roles.interface'
import { HandbookResolver, MappingBaseMaterialComponent, OrganizationResolver } from '@surgetech-eu/core'

export const EyemanRole: Role = {
    name: 'eyeman',
    title: 'Frame Manufacturer',
    icon: 'ion-ios-glasses',
    pages: [
        {
            title: 'Link Eyewear - Component & Galvanic Treatments',
            name: 'link',
            icon: 'ion-link',
            children: [
                {
                    route: ['/', 'eyewear', 'prepare-link'],
                    title: 'Prepare Link Eyewear/Component',
                    name: 'prepare-link'
                },
                {
                    route: ['/', 'eyewear', 'manage-link'],
                    title: 'Manage Link Eyewear - Component',
                    name: 'manage-link'
                },

                {
                    route: ['/', 'eyewear', 'prepare-link-treatments'],
                    title: 'Prepare Link Eyewear/Galvanic Treatments',
                    name: 'prepare-link-treatments'
                },
                {
                    route: ['/', 'eyewear', 'manage-link-treatments'],
                    title: 'Manage Link Eyewear/Galvanic Treatments',
                    name: 'manage-link-treatments'
                },
                {
                    route: ['/', 'eyewear', 'link-versioning'],
                    title: 'Versioning',
                    name: 'link-versioning'
                },
                {
                    route: ['/', 'eyewear', 'view-link'],
                    title: 'View Manual Component',
                    name: 'view-link'
                },
                {
                    route: ['/', 'eyewear', 'view-galvanic-treatment-link'],
                    title: 'View Manual Galvanic Treatments',
                    name: 'view-galvanic-treatment-link'
                }
                // {
                //   route: ['/', 'eyewear', 'link-lens'],
                //   title: 'Lens',
                //   name: 'link-lens',
                // },
                // {
                //   route: ['/', 'eyewear', 'link-acetate'],
                //   title: 'Acetate',
                //   name: 'link-acetate',
                // },
                //   {
                //       route: ['/', 'eyewear', 'link-component'],
                //       title: 'Component',
                //       name: 'link-component',
                //   },
            ]
        },
        {
            route: ['/', 'eyewear', 'lens-technical-validation'],
            title: 'Lens Technical Validation',
            name: 'lens-technical-validation',
            icon: 'ion-ios-refresh'
        },
        {
            route: ['/', 'data-mapping'],
            title: 'Data Mapping',
            name: 'data-mapping',
            icon: 'ion-shuffle'
        },
        // { TODO: phase 3
        //     route: ['/', 'versioning-history'],
        //     title: 'Versioning History',
        //     name: 'versioning-history',
        //     icon: 'ion-arrow-shrink'
        // },
        {
            route: ['/', 'eyeman', 'mapping', 'base-material'],
            title: 'Base Material',
            name: 'baseMaterial',
            icon: 'ion-ios-paper'
        },
        {
            title: 'Drop Ball Test',
            name: 'drop-ball-test',
            icon: 'ion-settings',
            children: [
                {
                    name: 'selectAndCreateDropBallTest',
                    route: ['/', 'drop-ball-test', 'select-and-create'],
                    title: 'Select and Create'
                },
                {
                    name: 'uploadAndCreateDropBallTest',
                    route: ['/', 'drop-ball-test', 'upload-and-create'],
                    title: 'Upload and Create'
                }
            ]
        },
        {
            title: 'Certification',
            name: 'certification',
            icon: 'ion-document-text',
            children: [
                {
                    name: 'player',
                    route: ['/', 'certification', 'player'],
                    title: 'Player'
                }
            ]
        },
        {
            route: ['/', 'eyeman', 'history', 'eyewear-data-mapping'],
            title: 'History',
            name: 'history',
            icon: 'ion-shuffle'
        }
    ],
    modules: {
        commonModules: [
            {
                path: 'eyewear',
                name: 'EyewearModule',
                load: () => import('../eyeman/eyewear/eyewear.module').then(m => m.EyewearModule)
            },
            {
                path: 'certification',
                name: 'CertificationModule',
                load: () => import('../eyeman/certification/certification.module').then(m => m.CertificationModule)
            },
            {
                path: 'data-mapping',
                name: 'DataMappingModule',
                load: () => import('../eyeman/data-mapping/data-mapping.module').then(m => m.DataMappingModule)
            },
            {
                path: 'drop-ball-test',
                name: 'DropBallTestModule',
                load: () => import('../eyeman/drop-ball-test/drop-ball-test.module').then(m => m.DropBallTestModule)
            },
            {
                path: 'history',
                url: 'eyeman/history',
                name: 'HistoryModule',
                load: () => import('../eyeman/history/history.module').then(m => m.HistoryModule)
            },
            {
                path: 'link-version',
                url: 'versioning-history',
                name: 'LinkVersionModule',
                load: () => import('../eyeman/link-version/link-version.module').then(m => m.LinkVersionModule)
            }
        ],
        externalModules: [
            {
                path: 'eyeman/mapping',
                childPath: 'base-material',
                component: MappingBaseMaterialComponent,
                resolve: {
                    handbook: HandbookResolver,
                    organizations: OrganizationResolver
                }
            }
        ]
    }
}
